import React, { useEffect } from "react";
import { DatePicker } from "rsuite";
import { DateTime } from "luxon";

const UserDateInput = ({
  setDateClear,
  refs = React.createRef(),
  dateFormat = "yyyy-MM-dd",
  timeZone = "America/Chicago",
  ...props
}) => {
  useEffect(() => {
    if (setDateClear) {
      setDateClear(false);
    }
  }, []);
  return (
    <DatePicker
      oneTap 
      onChange={(date) => {
        refs.current.value = DateTime.fromJSDate(date)
          .setZone("utc")
          .toJSDate();
        if (props?.onChange) props?.onChange(date);
      }}
      defaultValue={
        props?.defaultValue
          ? DateTime.fromJSDate(props?.defaultValue)
            .setZone(timeZone)
            .toFormat(dateFormat)
          : null
      }
      format={dateFormat}
      {...props}
      placement="autoVerticalStart"
    />
  );
};

export default UserDateInput;
